var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavWarGridSvg0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 541.911 541.911",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M533.13,467.826h-47.451V74.091h47.451c4.604,0,8.334-3.735,8.334-8.334c0-4.607-3.729-8.337-8.334-8.337h-49.065V8.334 c0-4.599-3.735-8.334-8.334-8.334c-4.61,0-8.334,3.736-8.334,8.334v49.08H74.529V8.334C74.529,3.736,70.796,0,66.195,0 c-4.61,0-8.334,3.736-8.334,8.334v49.08H8.781c-4.607,0-8.334,3.73-8.334,8.337c0,4.599,3.727,8.334,8.334,8.334h49.08v393.74 H8.781c-4.607,0-8.334,3.735-8.334,8.334c0,4.61,3.727,8.334,8.334,8.334h49.08v49.083c0,4.599,3.724,8.334,8.334,8.334 c4.602,0,8.334-3.735,8.334-8.334v-48.339h392.868v48.339c0,4.599,3.724,8.334,8.334,8.334c4.599,0,8.334-3.735,8.334-8.334 v-49.083h49.065c4.604,0,8.334-3.724,8.334-8.334C541.464,471.561,537.735,467.826,533.13,467.826z M201.386,468.204H74.529 V340.413h126.857V468.204z M201.386,334.857H74.529V207.435h126.857V334.857z M201.386,201.504H74.529V74.091h126.857V201.504z M334.736,468.204H206.942V340.413h127.794V468.204z M334.736,334.857H206.942V207.435h127.794V334.857z M334.736,201.504H206.942 V74.091h127.794V201.504z M468.083,468.204H340.292V340.413h127.791V468.204z M468.083,334.857H340.292V207.435h127.791V334.857z M468.083,201.504H340.292V74.091h127.791V201.504z M323.411,323.414H218.503V218.5h104.907V323.414z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavWarGridSvg0);
export default __webpack_public_path__ + "static/media/nav-war-grid-svg-0.25d010ae0503192c36d3e17e11bd4444.svg";
export { ForwardRef as ReactComponent };